<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import {Highlights, Hero} from '@react-spectrum/docs';
import heroNarrow from 'url:../assets/ReactAria_Mobile_976x1025_1x.png';
import heroNarrow2x from 'url:../assets/ReactAria_Mobile_976x1025_2x.png';
import heroNarrowWebp from 'url:../assets/ReactAria_Mobile_976x1025_1x.webp';
import heroNarrow2xWebp from 'url:../assets/ReactAria_Mobile_976x1025_2x.webp';
import heroWide from 'url:../assets/ReactAria_976x445_1x.png';
import heroWide2x from 'url:../assets/ReactAria_976x445_2x.png';
import heroWideWebp from 'url:../assets/ReactAria_976x445_1x.webp';
import heroWide2xWebp from 'url:../assets/ReactAria_976x445_2x.webp';

---
category: Libraries
description: A library of React Hooks that provides accessible UI primitives for your design system.
---

# React Aria

A library of React Hooks that provides accessible UI primitives for your design system.

<a href="getting-started.html" style={{fontSize: 18}}>Get started</a>

<Hero
  narrow={heroNarrow}
  narrow2x={heroNarrow2x}
  narrowWebp={heroNarrowWebp}
  narrow2xWebp={heroNarrow2xWebp}
  wide={heroWide}
  wide2x={heroWide2x}
  wideWebp={heroWideWebp}
  wide2xWebp={heroWide2xWebp}
  alt="React Aria hero image" />

<Highlights items={[
  {
    title: 'Accessible',
    description: <>React Aria provides accessibility and behavior according to <a href="https://www.w3.org/TR/wai-aria-practices-1.2/" target="_blank">WAI-ARIA Authoring Practices</a>, including full screen reader and keyboard navigation support. All components have been tested across a wide variety of screen readers and devices to ensure the best experience possible for all users.</>
  },
  {
    title: 'Adaptive',
    description: 'React Aria ensures consistent behavior, no matter the UI. It supports mouse, touch, keyboard, and screen reader interactions that have been tested across a wide variety of browsers, devices, and platforms.',
  },
  {
    title: 'International',
    description: 'React Aria supports over 30 languages, including right-to-left-specific behavior, internationalized date and number formatting, and more.'
  },
  {
    title: 'Fully customizable',
    description: 'React Aria doesn’t implement any rendering or impose a DOM structure, styling methodology, or design-specific details. It provides behavior, accessibility, and interactions and lets you focus on your design.'
  }
]} />
